import script from "./GlobalErrorOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalErrorOverlay.vue?vue&type=script&setup=true&lang=js"

import "./GlobalErrorOverlay.vue?vue&type=style&index=0&id=592863a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592863a1"]])

export default __exports__